module.exports = __webpack_public_path__ + "static/media/34-transporttjenester.22e2dfd6.mp3";